module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pane-box"
  }, [_c('div', {
    staticClass: "pane-label"
  }, [_c('div'), _vm._v(_vm._s(_vm.label) + " "), (_vm.label == '矫治方案') ? _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("\n      总计: "), _c('span', {
    staticStyle: {
      "color": "#5E8EFC"
    }
  }, [_vm._v(_vm._s(_vm.orthodonticsData.bracesCount))]), _vm._v(" 副 （需补缴 "), _c('span', {
    staticStyle: {
      "color": "#5E8EFC"
    }
  }, [_vm._v(_vm._s(_vm.orthodonticsData.addPrice))]), _vm._v(" 元）")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.label != 'CNC制造文件'),
        expression: "label != 'CNC制造文件'"
      }],
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [_c('a', {
      style: (['ppt', 'pptx', 'ppsx', 'ppsm', 'pot', 'potm', 'pdf', 'ppt', 'mp4', 'stl'].includes(item.name.substring(item.name.lastIndexOf('.') + 1)) ? '' : 'color:#606266;'),
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.selOpenFile(index, item)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.label == 'CNC制造文件'),
      expression: "label == 'CNC制造文件'"
    }]
  }, _vm._l((_vm.dataList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "pane-download"
    }, [_c('div', {
      staticClass: "down-file-wrap"
    }, [_c('div', {
      staticClass: "down-file"
    }, [(_vm.isJson) ? _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item.url)))]) : _c('div', [_vm._v("." + _vm._s(_vm.getFileType(item)))])]), _vm._v(" "), ((_vm.servCataId == '1010698' || _vm.servCataId == '1010699') && _vm.common.serv.get(_vm.servCataId).isDesignData === '0') ? _c('div', {
      staticClass: "down-file-des"
    }, [(_vm.isJson) ? _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPdf(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.toPdf(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.renameFileName(item) + '_' + index + '.' +
      _vm.getFileType(item)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "down-file-des"
    }, [(item.name.substring(item.name.lastIndexOf('.') + 1) == 'stl') ? _c('a', {
      on: {
        "click": _vm.to3dModel
      }
    }, [_vm._v(_vm._s(item.name))]) : (_vm.isJson) ? _c('label', [_vm._v(_vm._s(item.name))]) : _vm._e()])]), _vm._v(" "), (_vm.isJson) ? _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          return _vm.downFile(item.url, item.name)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })]) : _c('div', {
      staticClass: "down-button",
      on: {
        "click": function($event) {
          _vm.downFile(item, _vm.renameFileName(item) + '_' + index + '.' + _vm.getFileType(item))
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-download"
    })])])
  }), 0), _vm._v(" "), (_vm.dataList.length <= 0) ? _c('div', {
    staticClass: "pane-download"
  }, [_vm._m(0)]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4a372a2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/detailData.vue
// module id = 664
// module chunks = 0